<template>
  <div class="section">
    <OneHead 
      :brandClass="brandClass()" :isHeader="false">
      <template v-slot:title>{{$toUpperCase($t("profile_vehicle_summary_title"))}}</template>
      <template v-slot:subtitle>{{$t("profile_vehicle_summary_subtitle")}}</template>
    </OneHead>

    <div class="vehicle-list">
      <div v-for="(vehicle, index) in this.getVehicles" :key="`vehicle-${index}`" class="vehicle">
        <div class="vehicle-description">
          <div class="vehicle-model">{{vehicle.model}}</div>
          <div class="vehicle-vin">VIN: {{vehicle.vin}}</div>
        </div>
        <div>
          <div class="vehicle-image">
            <img v-if="vehicle.picture=='bmwCar'" src="@/assets/default/light/placeholder-bmw-default-light.png" alt="Car image sample">
            <img v-else-if="vehicle.picture=='bmwbike'" src="@/assets/default/light/placeholder-motorrad-default-light.png" alt="Car image sample">
            <img v-else-if="vehicle.picture=='mini'" src="@/assets/default/light/placeholder-mini-default-light.png" alt="Car image sample">
            <img v-else :src="vehicle.picture" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="vehicle-button-container">
      <OneButton
        :brandClass="brandClass()"
        class="vehicle-btn"
        v-if="$c('link_manage_vehicles')"
        :profileStyle="true"
        :type="'secondary'"
        :label="$t('profile_vehicle_summary_button')"
        @click="manageClick()"
      />
    </div>
  </div>
</template>

<script>
import oneUtils from "../../../../gcdm-one-library/gcdm-one-utils/src/bootstrap";

export default {
  inject:['$c', '$t', 'brandClass', '$toUpperCase'],
  name: "VehiclesSection",
  props: {
    user: {}
  },
  data: () => ({
    vehicles: {}
  }),
  mounted:function(){
    this.getVis();
  },
  computed:{
    getVehicles(){
      return this.vehicles;
    }
  },
  methods: {
    /**
     * this function get the list of user's vehicles
     */
    getVis(){
      oneUtils.utils.showGlobalLoader();
      const promises = [];
      for (const key in this.user.vehicles) {
        this.vehicles[this.user.vehicles[key].vin]={
          vin: this.user.vehicles[key].vin,
          model: this.user.vehicles[key].model,
          brand: this.user.vehicles[key].brand,
          picture: 'bmwCar'
        }
        promises.push(oneUtils.httpClient
        .getVis(this.user.vehicles[key].vin, this.$store.state.configurationParams.language, this.$store.state.configurationParams.country));
      }
      Promise.allSettled(promises).then((results) => {
        results.forEach(
          (result) => {
              if(result.status!='rejected'){
                  this.vehicles[result.value.vinLong]={
                      vin: result.value.vinLong,
                      model: result.value.model && result.value.model.text,
                      brand: result.value.brand,
                      picture: result.value.imageUrls ? result.value.imageUrls.VEHICLE_VIEW_50 : result.value.brand
                  };
                  this.$forceUpdate();
              }
          }
        );
        oneUtils.utils.hideGlobalLoader();
      });
    },

    /**
     * thsi function do the redirect to the link manage vehicles URL in the appropriate language
     */
    manageClick(){
      window.location.href=this.$c('link_manage_vehicles').replace("${language}", this.$store.state.configurationParams.language).replace("${country}", this.$store.state.configurationParams.country.toLowerCase());
    }
  },
  watch: {
    "$store.state.configurationParams": {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal.language !== oldVal.language) {
          console.log(`[VehiclesSection] language change detected: '${oldVal.language}' -> '${newVal.language}'`);
          this.getVis();
        }
      },
    },
  },
};
</script>

<style lang="scss">
.vehicle-list{
  display: flex;
  flex-direction: column;
  .vehicle{
    height: 240px;
    margin-top: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .vehicle-description{
      .vehicle-model{
        font-size: 20px;
        line-height: 28px;
        font-weight: bold;
        margin-bottom: 8px;
      }
      .vehicle-vin{
        font-size: 12px;
        line-height: 16px;
      }  
    }
    .vehicle-image{
      width: 300px;
      margin-right: 60px;
      display: flex;
      
      img{
        max-width: 100%;
        height: auto;
      }
    }
  }
}
.vehicle-button-container{
  text-align: center;
  width: 260px;
  margin: 45px auto;
  button{
    &.custom-button{
      &.vehicle-btn{
        width: 100%;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .vehicle-list{
    .vehicle{
      margin-top: 32px;
      display: flex;
      flex-direction: column-reverse;
      align-items: end;
      justify-content: space-between;
      .vehicle-description{
        .vehicle-model{
          font-size: 16px;
          line-height: 24px;
        }
        .vehicle-vin{
        }  
      }
      .vehicle-image{
        margin-top: 30px;
        margin-right: 0;
        width: 300px;
      }
    }
  }
  .vehicle-button-container{
    // width: 100%;
    margin: 45px auto;
  }
}
</style>
